<template>
  <svg :width="width" :height="height" viewBox="0 0 18 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M17.2008 2.57582L15.1742 0.54918C14.8226 0.197548 14.3456 2.6003e-06 13.8484 0L7.125 0C6.08945 0 5.25 0.839453 5.25 1.875V3.75H2.125C1.08945 3.75 0.25 4.58945 0.25 5.625V18.125C0.25 19.1605 1.08945 20 2.125 20H10.875C11.9105 20 12.75 19.1605 12.75 18.125V16.25H15.875C16.9105 16.25 17.75 15.4105 17.75 14.375V3.90164C17.75 3.40436 17.5525 2.92745 17.2008 2.57582ZM10.6406 18.125H2.35938C2.29721 18.125 2.2376 18.1003 2.19365 18.0564C2.14969 18.0124 2.125 17.9528 2.125 17.8906V5.85938C2.125 5.79721 2.14969 5.7376 2.19365 5.69365C2.2376 5.64969 2.29721 5.625 2.35938 5.625H5.25V14.375C5.25 15.4105 6.08945 16.25 7.125 16.25H10.875V17.8906C10.875 17.9528 10.8503 18.0124 10.8064 18.0564C10.7624 18.1003 10.7028 18.125 10.6406 18.125ZM15.6406 14.375H7.35938C7.29721 14.375 7.2376 14.3503 7.19365 14.3064C7.14969 14.2624 7.125 14.2028 7.125 14.1406V2.10938C7.125 2.04721 7.14969 1.9876 7.19365 1.94365C7.2376 1.89969 7.29721 1.875 7.35938 1.875H11.5V5.3125C11.5 5.83027 11.9197 6.25 12.4375 6.25H15.875V14.1406C15.875 14.2028 15.8503 14.2624 15.8064 14.3064C15.7624 14.3503 15.7028 14.375 15.6406 14.375ZM15.875 4.375H13.375V1.875H13.7512C13.8134 1.875 13.873 1.89969 13.917 1.94363L15.8064 3.83301C15.8281 3.85477 15.8454 3.88061 15.8572 3.90905C15.8689 3.93749 15.875 3.96797 15.875 3.99875V4.375Z" fill="#9CA3AF"/>
  </svg>
</template>

<script>
    export default {
        name: "IconCopy",
        props: {
          width: {
            type: Number,
            default: 18
          },
          height: {
            type: Number,
            default: 20
          },
        },
    }
</script>

<style scoped>

</style>
